import React from 'react';
import { TreeTable } from 'primereact/treetable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useState, useEffect } from 'react';

const DocumentosTreeTable = ({
    value,
    header,
    selectedKeys,
    onSelectionChange,
    onDownload,
    onDownloadFinal,
    onCreateDoc,
    onUploadPdf,
    onEditDoc,
    onUploadFinal,
    onDelete,
    onDeleteFinal,
    }) => {

        const [isMobile, setIsMobile] = useState(false);

        useEffect(() => {
            const mql = window.matchMedia('(max-width: 768px)');
            const handler = (e) => setIsMobile(e.matches);
            setIsMobile(mql.matches);
            mql.addEventListener('change', handler);
            return () => mql.removeEventListener('change', handler);
        }, []);
    
    return (
        <div className="card">
            <TreeTable
                value={value}
                header={header}
                paginator
                rows={isMobile ? 5 : 10}
                rowsPerPageOptions={isMobile ? [5, 10, 20] : [10, 20, 50, 100]}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
                currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} clientes"
                scrollable
                scrollHeight={isMobile ? '65vh' : '57vh'}
                selectionKeys={selectedKeys}
                onSelectionChange={(e) => onSelectionChange(e.value)}
                showGridlines
                className="p-datatable-gridlines"
                stripedRows="true"
                emptyMessage="No se encontraron documentos."
                tableStyle={{ tableLayout: "fixed", width: "100%", minWidth: "1000px" }}
            >
            <Column
                field="name"
                header="Cliente"
                expander
                style={{ width: isMobile ? '100%' : '35%' }}
                sortable
                body={(node) => {
                    const label = node.data?.name || '';
                    const idDoc = node.data?.id_documento;
                    const isFinal = node.data?.id_documento_final;

                    // ===== INICIO VISTA MÓVIL =====
                    if (isMobile) {
                        const name = node.data?.name || '';
                        const isAsignacion = name.includes('Asignación');
                        const isDoc = node.data?.id_documento;
                        const isPdf = node.data?.id_documento_final;
                        const isFinalRow =
                            !!node?.data?.id_documento_final ||
                            (Array.isArray(node?.children) &&
                                node.children.some(
                                    (child) =>
                                        !!child?.data?.id_documento_final ||
                                        !!child?.data?.filename_final ||
                                        (typeof child?.key === 'string' && child.key.startsWith('final-')) ||
                                        (typeof child?.data?.tipo === 'string' && child.data.tipo.toLowerCase().includes('final')
                                        )
                                ));

                        return (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                {/* Línea superior: nombre a la izquierda, acciones a la derecha */}
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '0.5rem' }}>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        {idDoc && !isFinal ? (
                                            <Button
                                                label={label}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    onDownload(idDoc, label);
                                                }}
                                                icon="pi pi-file-word"
                                                className="p-button p-button-sm p-button-rounded p-button-outlined"
                                                tooltip="Descargar Word"
                                                tooltipPosition="top"
                                            />
                                        ) : isFinal ? (
                                            <Button
                                                label={label}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    onDownloadFinal(isFinal, label);
                                                }}
                                                icon="pi pi-file-pdf"
                                                className="p-button p-button-sm p-button-rounded p-button-outlined p-button-danger"
                                                tooltip="Descargar PDF"
                                                tooltipPosition="top"
                                            />
                                        ) : (
                                            <span>{label}</span>
                                        )}
                                    </div>

                                    <div style={{ display: 'flex', gap: '0.25rem', flexShrink: 0 }}>
                                        {isAsignacion && (
                                            <Button
                                                tooltip="Crear Documento"
                                                tooltipPosition="top"
                                                icon="pi pi-plus"
                                                label="Crear"
                                                onClick={() =>
                                                    onCreateDoc(
                                                        node.data?.empresa,
                                                        node.data?.id_contrato,
                                                        node.data?.id_empresa,
                                                        node.data?.id_cliente,
                                                        node.data?.razon_social
                                                    )
                                                }
                                                className="p-button p-button-rounded p-button-success p-button-sm p-button-outlined"
                                            />
                                        )}
                                        {isDoc && (
                                            <>
                                                <Button
                                                    tooltip="Editar Documento"
                                                    tooltipPosition="top"
                                                    icon="pi pi-pencil"
                                                    onClick={() =>
                                                        onEditDoc(
                                                            node.data?.id_documento,
                                                            node.data?.variables_json,
                                                            node.data?.metadata_json,
                                                            node.data?.filename,
                                                            node.data?.id_estado_documento
                                                        )
                                                    }
                                                    className="p-button  p-button-rounded p-button p-button-sm p-button-outlined"
                                                    disabled={isFinalRow}
                                                />
                                                <Button
                                                    tooltip="Anular Documento"
                                                    tooltipPosition="top"
                                                    icon="pi pi-times"
                                                    onClick={() => {
                                                        if (window.confirm('¿Estás seguro de anular este documento?')) {
                                                            onDelete(node.data?.id_documento);
                                                        }
                                                    }}
                                                    className="p-button  p-button-rounded p-button-secondary p-button-sm p-button-outlined"
                                                    disabled={isFinalRow}
                                                />
                                                <Button
                                                    tooltip="Subir Documento Final"
                                                    tooltipPosition="top"
                                                    icon="pi pi-file-pdf"
                                                    onClick={() => {
                                                        onUploadFinal(node.data?.id_documento, 
                                                            node.data?.id_contrato, 
                                                            node.data?.id_tipo_documento
                                                        );
                                                    }}
                                                    className="p-button  p-button-rounded p-button-danger p-button-sm p-button-outlined"
                                                />
                                            </>
                                        )}
                                        {isPdf && (
                                            <Button
                                                tooltip="Anular Documento"
                                                tooltipPosition="top"
                                                icon="pi pi-times"
                                                onClick={() => {
                                                    if (window.confirm('¿Estás seguro de anular este documento?')) {
                                                        onDeleteFinal(node.data?.id_documento_final);
                                                    }
                                                }}
                                                className="p-button  p-button-rounded p-button-secondary p-button-sm p-button-outlined"
                                            />
                                        )}
                                    </div>
                                </div>

                                {/* Bloque de detalle debajo */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.25rem', fontSize: '0.8rem', opacity: 0.9 }}>
                                    {(isDoc || isFinalRow || isPdf) && (
                                        <>
                                        <div><strong>Detalle:</strong> {node.data?.tipo || '-'}</div>
                                        <div><strong>Estado:</strong> {node.data?.estado || '-'}</div>
                                        <div style={{ gridColumn: '1 / -1' }}><strong>Fecha/Hora:</strong> {node.data?.actualizacion || '-'}</div>
                                        </>
                                    )}
                                </div>
                            </div>
                        );
                    }
                    // ===== FIN VISTA MÓVIL =====

                    // Versión escritorio sin cambios
                    if (idDoc && !isFinal) {
                        return (
                            <Button
                                label={label}
                                onClick={(e) => {
                                    e.preventDefault();
                                    onDownload(idDoc, label);
                                }}
                                icon="pi pi-file-word"
                                className="p-button p-button-sm p-button-rounded p-button-outlined"
                                tooltip="Descargar Word"
                                tooltipPosition="top"
                            />
                        );
                    } else if (isFinal) {
                        return (
                            <Button
                                label={label}
                                onClick={(e) => {
                                    e.preventDefault();
                                    onDownloadFinal(isFinal, label);
                                }}
                                icon="pi pi-file-pdf"
                                className="p-button p-button-sm p-button-rounded p-button-outlined p-button-danger"
                                tooltip="Descargar PDF"
                                tooltipPosition="top"
                            />
                        );
                    }
                    return <span>{label}</span>;
                }}
            />
            {!isMobile && <Column field="tipo" header="Detalle" sortable />}
            {!isMobile && <Column field="estado" header="Estado" sortable />}
            {!isMobile && <Column field="actualizacion" header="Fecha/Hora" sortable />}
            {!isMobile && (
                <Column
                    field="acciones"
                    header="Acciones"
                    body={(node) => {
                        const name = node.data?.name || '';
                        const isAsignacion = name.includes('Asignación');
                        const isDoc = node.data?.id_documento;
                        const isPdf = node.data?.id_documento_final;
                        const isFinal =
                            !!node?.data?.id_documento_final ||
                            (Array.isArray(node?.children) &&
                                node.children.some(
                                    (child) =>
                                        !!child?.data?.id_documento_final ||
                                        !!child?.data?.filename_final ||
                                        (typeof child?.key === 'string' && child.key.startsWith('final-')) ||
                                        (typeof child?.data?.tipo === 'string' && child.data.tipo.toLowerCase().includes('final'))
                                ));

                        return (
                            <>
                                {isAsignacion && (
                                    <>
                                        <Button
                                            tooltip="Crear Borrador"
                                            tooltipPosition="top"
                                            icon="pi pi-plus"
                                            label="Crear"
                                            onClick={() =>
                                                onCreateDoc(
                                                    node.data?.empresa,
                                                    node.data?.id_contrato,
                                                    node.data?.id_empresa,
                                                    node.data?.id_cliente,
                                                    node.data?.razon_social
                                                )
                                            }
                                            className="p-button p-button-rounded p-button-success p-button-sm p-button-outlined mr-2 mt-2"
                                        />

                                        <Button
                                            tooltip="Subir PDF"
                                            tooltipPosition="top"
                                            icon="pi pi-file-pdf"
                                            label="Subir"
                                            onClick={() =>
                                                onUploadPdf(
                                                    node.data?.id_contrato,
                                                    node.data?.empresa
                                                )
                                            }
                                            className="p-button p-button-rounded p-button-danger p-button-sm p-button-outlined mt-2"
                                        />
                                    </>
                                )}
                                {isDoc && (
                                    <>
                                        <Button
                                            tooltip="Editar Documento"
                                            tooltipPosition="top"
                                            icon="pi pi-pencil"
                                            onClick={() =>
                                                onEditDoc(
                                                    node.data?.id_documento,
                                                    node.data?.variables_json,
                                                    node.data?.metadata_json,
                                                    node.data?.filename,
                                                    node.data?.id_estado_documento
                                                )
                                            }
                                            className="p-button  p-button-rounded p-button p-button-sm p-button-outlined ml-2"
                                            disabled={isFinal}
                                        />
                                        <Button
                                            tooltip="Anular Documento"
                                            tooltipPosition="top"
                                            icon="pi pi-times"
                                            onClick={() => {
                                                if (window.confirm('¿Estás seguro de anular este documento?')) {
                                                    onDelete(node.data?.id_documento);
                                                }
                                            }}
                                            className="p-button  p-button-rounded p-button-secondary p-button-sm p-button-outlined ml-2 mt-2"
                                            disabled={isFinal}
                                        />
                                        <Button
                                            tooltip="Subir Documento Final"
                                            tooltipPosition="top"
                                            icon="pi pi-file-pdf"
                                            onClick={() => {
                                                onUploadFinal(node.data?.id_documento,
                                                    node.data?.id_contrato,
                                                    node.data?.id_tipo_documento
                                                );
                                            }}
                                            className="p-button  p-button-rounded p-button-danger p-button-sm p-button-outlined ml-2 mt-2"
                                        />
                                    </>
                                )}
                                {isPdf && (
                                    <>
                                        <Button
                                            tooltip="Anular Documento"
                                            tooltipPosition="top"
                                            icon="pi pi-times"
                                            onClick={() => {
                                                if (window.confirm('¿Estás seguro de anular este documento?')) {
                                                    onDeleteFinal(node.data?.id_documento_final);
                                                }
                                            }}
                                            className="p-button  p-button-rounded p-button-secondary p-button-sm p-button-outlined ml-2 mt-2"
                                        />
                                    </>
                                )}
                            </>
                        );
                    }}
                />
            )}
            </TreeTable>
        </div>
    );
};

export default DocumentosTreeTable;